import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CommonButton from '../atoms/CommonButton';

const styles = {};

const enhance = compose();
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  }
});

const Main = enhance(
  ({ open, onClose, okAction, message, isSmall, btnTitle }) => {
    const classes = useStyles();
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classes.paperWidthSm
        }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CommonButton title={btnTitle} onClickAction={okAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
